/* Copyright (c) 2019 VMware, Inc. All rights reserved. -- VMware Confidential */

module platform {
    import IComponentOptions = angular.IComponentOptions;
    import IComponentController = angular.IComponentController;

    class FolderSummary implements IComponentOptions {
        public bindings = {
            data: "=",
            resourceBundle: "="
        };
        public templateUrl = "resources/ui/views/summary/vxFolderSummaryTemplate.html";
        public controller = FolderSummaryController;
    }

    class FolderSummaryController implements IComponentController {

        public i18n: (module: string, key: string) => string;
        public objectId: string;

        public static $inject = [
          "i18nService",
          "navigation"
        ];

        constructor(
            private i18nService: i18nService,
            private navigation: any
        ) {
            this.i18n = i18nService.getString;
            this.objectId = navigation.getObjectId();
        }
        getSummaryItemLabel(summaryItem) {
            return summaryItem.label ? this.i18n(this.resourceBundle, summaryItem.label) : "\u00A0";
        };
        getSummaryItemValue(summaryItem) {
            return summaryItem.value;
        };
        navigateTo(item) {

            /**
             * Navigate to corresponding tab
             * Checking the label as the lableValue object in FolderSummaryData.java cannot be changed,
             * because this may affect other summary tab also.
             * TODO: Need to change it to check the type instead of label.
             */
            if (item.label === "summary.clusterCount") {
                this.navigation.navigateToViewAndObject("vsphere.core.relateditems.specs.vcenter.hosts.clustersForVCenter", this.objectId);
            } else if (item.label === "summary.hostCount") {
                this.navigation.navigateToViewAndObject("vsphere.core.relateditems.specs.vcenter.hosts.hostsForVCenter", this.objectId);
            } else if (item.label === "summary.vmCount") {
                this.navigation.navigateToViewAndObject("vsphere.core.folder.relatedVMsTab", this.objectId);
            } else {
                this.navigation.navigateToViewAndObject("vsphere.core.folder.summary", this.objectId);
            }
        };
    }

    angular.module("com.vmware.platform.ui").component(
          "vxFolderSummary",
          new FolderSummary()
    );
}
